import { render, staticRenderFns } from "./LegendList.vue?vue&type=template&id=68e77d9a&scoped=true&"
import script from "./LegendList.vue?vue&type=script&lang=js&"
export * from "./LegendList.vue?vue&type=script&lang=js&"
import style0 from "./LegendList.vue?vue&type=style&index=0&id=68e77d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e77d9a",
  null
  
)

export default component.exports